// @auto-index

import facebook from './facebook'
import github from './github'
import linkedIn from './linked-in'
import stackOverflow from './stack-overflow'
import twitter from './twitter'

export { default as facebook } from './facebook'
export { default as github } from './github'
export { default as linkedIn } from './linked-in'
export { default as stackOverflow } from './stack-overflow'
export { default as twitter } from './twitter'

export default {
  facebook,
  github,
  linkedIn,
  stackOverflow,
  twitter
}
